import { createContext } from "react";

export const defaultUserDetails = {
  userDetails: {
    voornaam: "",
    tussenvoegsels: "",
    achternaam: "",
    roepnaam: null,
    voorletters: "",
    telefoon: null,
    telefoonWerk: null,
    telefoonMobiel: null,
    geslacht: "Man",
    email: "",
    functie: null,
    platformId: null,
    klantId: null,
    isActief: false,
    klantdossierRechtenVestigingen: null,
    klantdossierRechtenOrganisatie: null,
    medewerkerId: "",
    organisatieId: ""
  },
  setUserDetails: (_userDetails: any): void => {}
};

const UserDetailsContext = createContext(defaultUserDetails);

export default UserDetailsContext;
